var mask = "/static/ab263c0948c92265.png";

export { mask as default };
//# sourceMappingURL=mask.png.js.map
